<template>
  <div>
    <s-crud title="Detalle Categorías" :config="config" @save="save($event)" add edit remove :filter="filter"
      ref="crudDetalleCategorias" height="auto" @addEvent="addMasive = false" @rowSelected="showFormRef()">

      <template v-slot:options v-if="addMasive">
        <v-tooltip bottom="">
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text black @click="addEventMasive($event)" small>
              <v-icon>mdi-plus-circle-multiple-outline</v-icon>
            </v-btn>
          </template>
          <span>Registro Masivo</span>
        </v-tooltip>
      </template>

      <template scope="props">
        <v-container disabled=props.item.C>
          <v-row justify="center">
            <v-col v-if="TypeShip != 2" cols="12" class="s-col-form">
              <s-select-definition label="Calibre" :def="1266" return-object v-model="ObjCaliber"></s-select-definition>
            </v-col>
            <v-col v-if="TypeShip == 2" cols="12" class="s-col-form">
              <s-select-definition label="Calibre" :def="1326" return-object v-model="ObjCaliber"></s-select-definition>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="s-col-form">
              <s-date label="Fecha Inicio" v-model="props.item.DctgDateStar"></s-date>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="s-col-form">
              <s-date label="Fecha Fin" v-model="props.item.DctgDateEnd"></s-date>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="s-col-form">
              <s-select-definition v-model="props.item.DctgStatus" :def="1221" label="Estado"></s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form">
              <s-text v-model="props.item.DctgObservation" label="Observación">
              </s-text>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:Estado="{ row }">
        <v-chip style="margin: 0px" x-small :color="row.Estado == 'Inactivo' ? 'error' : 'success'">
          {{ row.Estado }}
        </v-chip>
      </template>
    </s-crud>

    <v-dialog width="700px" persistent v-model="dialogRegister">
      <v-card>
        <s-toolbar @save="saveMassive()" save close @close="closeDialogRegister()" label="Carga masiva" />
        <v-divider></v-divider>

        <!-- <v-card> -->
        <v-container>
          <v-row justify="center">
            <v-col v-if="TypeShip != 2" cols="12" class="s-col-form">
              <s-select-definition label="Calibre" multiple :def="1266" dense hide-details
                v-model="selectedTypeCaliber"></s-select-definition>
            </v-col>
            <v-col v-if="TypeShip == 2" cols="12" class="s-col-form">
              <s-select-definition label="Calibre" multiple :def="1326" dense hide-details
                v-model="selectedTypeCaliber"></s-select-definition>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="s-col-form">
              <s-date label="Fecha Inicio" v-model="paymentCategory.DctgDateStar"></s-date>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="s-col-form">
              <s-date label="Fecha Fin" v-model="paymentCategory.DctgDateEnd"></s-date>
            </v-col>
            <v-col cols="12" lg="4" md="4" sm="12" class="s-col-form">
              <s-select-definition v-model="paymentCategory.DctgStatus" :def="1221"
                label="Estado"></s-select-definition>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <s-text v-model="paymentCategory.DctgObservation" label="Observación">
              </s-text>
            </v-col>
          </v-row>
        </v-container>
        <!-- </v-card> -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TasPaymentCategoryDetailServices from "@/services/Technicalassistance/TasPaymentCategoryDetailService";
import _sPaymentCategory from "@/services/Technicalassistance/TasPaymentCategoryService";
import SSelectDefinition from '../../../components/Utils/SSelectDefinition.vue';

export default {
  name: "RequirementServiceTasPaymentCategoryService",
  components: { SSelectDefinition },
  props: {
    CtgID: { type: Number, default: 0 },
    parentID: { type: Number, default: 0 },
    addNoFunction: { type: Boolean, default: false },
  },

  data: () => ({
    ObjCaliber: {},
    dialogEdit: false,
    filter: { CtgID: 0 },
    TypeShip: false,
    dialogRegister: false,
    addMasive: true,
    selectedTypeCaliber: null,
    paymentCategory: {
      DctgID: 0,
      CtgID: null,
      TypeCaliber: [],
      DctgDateStar: '',
      DctgDateEnd: '',
      DctgObservation: '',
      DctgDescription: '',
      SecStatus: 1,
    }
  }),

  computed: {
    config() {
      return {
        model: {
          //RETORNAR PROPIEDAD COMPUTADA
          DctgID: "ID",
          CtgID: "int",
          DctgDescription: "string",
          DctgObservation: "string",
          DctgStatus: "status",
          Estado: "string",
          DctgDateStar: 'date',
          DctgDateEnd: 'date'
          //
        },
        service: TasPaymentCategoryDetailServices,
        headers: this.$fun.getSecurity().IsLevelAdmin
          ? [
            //Vista de tabla para admin
            { text: "ID", value: "DctgID", sortable: false },
            { text: "Descripción", value: "DctgDescription", sortable: false, },
            { text: "Fecha Inicio", value: "DctgDateStar", sortable: false },
            { text: "Fecha Fin", value: "DctgDateEnd", sortable: false },
            { text: "Estado", value: "Estado", align: "center", sortable: false },
          ]
          : [
            // CABECERA EN CASO NO SE LOGEE COMO ADMIN
            { text: "ID", value: "DctgID", sortable: false },
            { text: "Descripción", value: "DctgDescription", sortable: false, },
            { text: "Categoria", value: "CtgDescription", sortable: false },
            { text: "Fecha Inicio", value: "DctgDateStar", sortable: false },
            { text: "Fecha Fin", value: "DctgDateEnd", sortable: false },
            { text: "Estado", value: "Estado", sortable: false },
          ],
        TypeShip: 0,
      };
    },

    isAdmin() {
      this.$fun.getSecurity().IsLevelAdmin;
    },
  },

  methods: {
    Initialize() {
      //DedID: this.DedID -- base de datos: campo actual
      this.filter = { CtgID: this.CtgID };
      _sPaymentCategory.searchPaymentCategoryByID(this.CtgID, this.$fun.getUserID()).then((res) => {
        console.log("res", res.data);
        this.TypeShip = res.data?.TypeShip || 0;
      });
    },

    showFormRef() {
      this.$nextTick(() => {
        const showForm = this.$refs.crudDetalleCategorias.showForm ?? false;
        if (!showForm) {
          this.addMasive = true;
        }
      })
    },

    addEventMasive() {
      this.dialogRegister = true;
      this.selectedTypeCaliber = null;
    },

    closeDialogRegister() {
      this.dialogRegister = false;
    },

    edit(item) {
      this.dialogEdit = true;
    },

    rowSelected(rows) {
      if (rows.length > 0) {
        this.$emit("rowSelected", rows);
      }
    },

    save(item) {
      const UserID = this.$fun.getUserID();
      item.CtgID = this.CtgID;
      item.SecStatus = 1;
      item.TypeCaliber = this.ObjCaliber.DedValue;
      item.DctgDescription = this.ObjCaliber.DedDescription;
      item.UsrCreateID = UserID;

      if (item.CtgID == 0) {
        this.$fun.alert("Seleccione la Categoria", "warning");
        return;
      }

      if (item.TypeCaliber == undefined || item.TypeCaliber == 0) {
        this.$fun.alert("Seleccione el Calibre", "warning");
        return;
      }

      if (item.DctgStatus == undefined || item.DctgStatus == "") {
        this.$fun.alert("Seleccione la Categoria", "warning");
        return;
      }

      item.save();

    },
    saveMassive() {

      if (this.CtgID == undefined || this.CtgID == 0) {
        this.$fun.alert("Seleccione la Categoria", "warning");
        return;
      }

      const selectedTypeCaliber = JSON.parse(this.selectedTypeCaliber) ?? [];
      if (selectedTypeCaliber.length == 0) {
        this.$fun.alert("Seleccione Calibres a registrar", "warning");
        return;
      }

      if (this.paymentCategory.DctgStatus == undefined || this.paymentCategory.DctgStatus == "") {
        this.$fun.alert("Seleccionar estado", "warning");
        return;
      }

      if (this.paymentCategory.DctgDateStar == undefined || this.paymentCategory.DctgDateStar == "") {
        this.$fun.alert("Seleccionar Fecha inicio", "warning");
        return;
      }

      if (this.paymentCategory.DctgDateEnd == undefined || this.paymentCategory.DctgDateEnd == "") {
        this.$fun.alert("Seleccionar Fecha fin", "warning");
        return;
      }

      this.$fun.alert("Seguro de agregar Registro?", "question").then(result => {
        if (result.value) {

          const UserID = this.$fun.getUserID();
          const data = selectedTypeCaliber.map((category_id) => ({
            DctgID: 0,
            CtgID: this.CtgID,
            DctgDateStar: this.paymentCategory.DctgDateStar,
            DctgDateEnd: this.paymentCategory.DctgDateEnd,
            DctgDescription: this.paymentCategory.DctgDescription,
            DctgObservation: this.paymentCategory.DctgObservation,
            DctgStatus: this.paymentCategory.DctgStatus,
            TypeCaliber: category_id,
            SecStatus: 1,
            UsrCreateID: UserID,
          }));
          TasPaymentCategoryDetailServices.saveMassive(data, UserID).then(resp => {
            if (resp.status == 200) {
              this.dialogRegister = false;
              this.addMasive = true;
              this.selectedTypeCaliber = null;
              this.paymentCategory = {
                DctgID: 0,
                CtgID: this.CtgID,
                TypeCaliber: [],
                DctgDateStar: null,
                DctgDateEnd: null,
                DctgObservation: '',
                DctgDescription: '',
                SecStatus: 1,
              }
              this.$refs.crudDetalleCategorias.refresh();
              this.$fun.alert("Agregado correctamente.", "success");
            }
          })
        }
      });
    }
  },
  watch: {
    // este DedID es el que esta en variety, vista general en DedID  ="dedID"
    CtgID() {
      this.Initialize();
    },
    ObjCaliber(item) {
      // console.log(item);
    }
  },
  created() {
    this.filter = { CtgID: this.CtgID };
  },
};
</script>
